import React from 'react'
import AdminImg from '../../Img/viewer.png';
import Viewer from '../../Img/viewer.png'
import Candidatevideo from '../../Img/Candidate.mp4'
// import Viewer from '../../Img/repository_user.png'
import BannerImg from '../../Img/Strategic-Modeling-using-Oracle-EPM.jpg'
// import campraImg from "../../Img/LOGORepository.png"
import campraImg from "../../Img/logo.png"
import HCM from '../../Img/hcm2.png';
import ERP from '../../Img/erp-2.png';
import SCM from '../../Img/scm-2.png';
import EPM from '../../Img/epm-2.png';
import CategoryList from './CategoryList';
import back from "../../Img/new home.png";
import { useNavigate } from 'react-router-dom';
import PdfViewer from './PdfViewer';
import TopArrowButton from '../TopArrowButton';
const SinglePost = () => {
  const storedEmail = localStorage.getItem('userEmail');
  console.log("storedEmail=", storedEmail);
  const navigate = useNavigate();
  const backBtn = () => {
    navigate("/searchLandingPage")
  }
  return (
    <div className="container-singlePost">
      <div className="left-main-div column left-column landing-left justify-content-start">
        {/* <!-- Content for the left column goes here --> */}
        <div className="logo-home others-campra-logo">
          <img src={campraImg} alt="" className='campra-log-img' />

        </div>

        <div className="repo landing text-white catagory-main-div ">
          {/* <p><strong>Knowledge Repository</strong></p> */}
          <CategoryList />
        </div>
      </div>
      <div className="column right-columnh ">
        {/* <!-- Content for the right column goes here --> */}
        {storedEmail == 'author@camptratech.com' ? <div className="header">
          <div className="back-screen">
            <button type="button"
              className="btn "
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Home"
              onClick={backBtn}><img src={back} alt="" className='table-logo' /></button>
          </div>
          <div className="user-det">
            <div className="usr-bac">
              <img src={AdminImg}
                style={{ width: '50px', height: '50px' }}
                alt="" />
              <div className="user-name">
                <p id="usrname">Ronin S</p>
                <p id="usrrole">Author</p>

              </div>

            </div>


          </div>
        </div>
          : <div className="header">
            <div className="back-screen">
              <button onClick={backBtn}><img src={back} alt="" className='table-logo' /></button>
            </div>
            <div className="user-det">
              <div className="usr-bac">
                <img src={Viewer}
                  style={{ width: '50px', height: '50px' }}
                  alt="" />
                <div className="user-name">
                  <p id="usrname">Rohit S</p>
                  <p id="usrrole">Viewer</p>

                </div>

              </div>


            </div>
          </div>
        }

        {/* <div className="header">
     <div className="user-det">
      <div className="usr-bac">
       <img src={AdminImg}
        style={{ width: '50px', height: '50px' }}
        alt="" />
       <div className="user-name">
        <p id="usrname">Ronin S</p>
        <p id="usrrole">Author</p>

       </div>

      </div>


     </div>
    </div> */}
        <div className="single-post">
          <h2>Strategic Modeling Using Oracle EPM: Long Range Planning for Uncertainties</h2>
          <div className="img-post my-4">
            <img src={BannerImg} className='w-100 ' height={500} alt="" />


          </div>
          <div className="main-content-post">
            <h3>Problem Statement</h3>
            <p>
              It’s no secret the coronavirus and recent Geo-Political Risks has completely shaken up life as we know it. It has affected people, businesses, and industries in ways that no one could foresee. During these unprecedented times, we need to return to the basics and take action to respond to economic crisis heading towards a recession.

              Organizations who understand the scenario and its impact and react with speed and enthusiasm will emerge stronger than ever from the crisis. Many Organizations have started taking aggressive strategies to address challenges resulting due to economic crisis. Below are the questions Executives are seeking answers for below listed questions.

            </p>
            <p>Scenario Analysis & Drawbacks of Conventional Scenario Analysis
              Scenario Analysis helps to identify and analysis the possible best-case and worst-case scenarios that would result due to unexpected economic, geopolitical, and technological challenges

              The best-case scenario takes into consideration what will happen if everything goes as planned by the Organisation whereas worst-case scenario includes the impact on the financials if things go negatively due to any external and internal factors. Traditional Method of Scenario Analysis through excel spreadsheets makes the process much complex which results into following drawbacks.

            </p>
            <p>Numerous meetings and workshops are needed to identify the various possible scenario and its occurrence which makes the process more time consuming.
              Due to manual process, it requires more resources in terms of time and investment that make the process costly.
              It is very difficult to accurately quantify the variables in terms of financial value even though the variables are known due to the nature of the variable which differs over time.</p>

            <div className='my-4'>
              <video className="w-100 " controls autoPlay loop muted style={{ objectFit: 'cover', height: '63.8vh', marginTop: '8px' }}>
                <source src={Candidatevideo} type="video/mp4" />

              </video>
            </div>

            <h5>Steps to Perform Scenario Analysis</h5>
            <ul>
              <li><p>Identifying the key assumptions underlying our forecasts and clearing presenting them in a robust planning model.</p></li>
              <li><p>Developing a base case.</p></li>
              <li><p>Identifying and modeling roughly 3-7 alternative scenarios and estimating their likelihood.</p></li>
              <li><p>Monitoring the critical assumptions listed in step 1 via a dashboard.</p></li>
              <li><p>Narrowing down and refining scenarios based as events play out.</p></li>
            </ul>
            <p>

            </p>
          </div>

          {/* <PdfViewer /> */}

        </div>



      </div>
    </div>
  )
}

export default SinglePost